const DROP_REASONS = {
  CONSENT: 'CONSENT',
  CONSENT_DEPRECATED: 'CONSENT_DEPRECATED',
  PLAYBOOK_FILTER: 'PLAYBOOK_FILTER',
  PIPELINE_LUA_FILTER: 'PIPELINE_LUA_FILTER',
};

export default DROP_REASONS;
